<template>
    <div class="overflow-x-hidden">
        <section
            class="benefits-section text-center  grid flex flex-wrap justify-content-center align-items-center py-6 md:px-4 md:px-6 relative">
            <div v-if="bgUrl" class="background-image" :style="{ backgroundImage: `url('${bgUrl}')`, zIndex: 0 }"></div>
            <div class="container px-4 md:px-6 relative ">
                <div class="grid justify-content-center  align-items-stretch">
                    <div v-for="(benefit, index) in benefits" :key="index" class="col-12 md:col-6 lg:col-4 px-4 mt-3 mb-3">
                        <div class="benefit-card p-5 border-round-xl w-full flex flex-column  text-center  "  v-animateonscroll="{ enterClass: 'animate-zoom-in' }">
                            <h3 class="Paragraph-Medium mb-3">{{ benefit.title }}</h3>
                            <p class="Caption px-6 mb-0 flex-grow-1">{{ benefit.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { usePublicUrl } from "@/utils/getPublicUrl"

const bgUrl = usePublicUrl("public/book.jpg");

const benefits = [
    {
        title: "Set your own rates",
        description: "Decide how much you earn by setting your own lesson rates",

    },
    {
        title: "Teach anytime, anywhere",
        description: "Choose when and where you teach, giving you full flexibility",

    },
    {
        title: "Verified tutors = trusted by students",
        description: "Get verified to build trust and attract more students",

    },
    {
        title: "Grow your profile and income",
        description: "Increase your visibility, reputation, and earnings over time",

    },
    {
        title: "Increase your visibility and reputation over time",
        description: "Inspire students with your knowledge and help them achieve their learning goals.",

    },

];
</script>
<style scoped>
.benefit-card {
    background-color: rgba(30, 100, 120, 0.49);
    height: 100%;
}

.background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 45%;
}
</style>